"use client";

import { Suspense } from "react";
import { useSearchParams } from "next/navigation";
import PublishForm from "@/components/publish/PublishForm";

export default function PublishPage() {
    return (
        <Suspense fallback={null}>
            <PublishPageInner />
        </Suspense>
    );
}

function PublishPageInner() {
    const editId = useSearchParams().get("edit");
    return <PublishForm editId={editId} />;
}
